const { saveSnapshot } = require('./utils/save-snapshot')
const HistoryItem = require('./utils/history-item.js')
const { log } = console
function loadSnapshot (snapshot, state) {
  const {stateData, vmData} = snapshot
  state.selectedGlitchApplication = null

  state.vm.runtime.targets.forEach(t => {
    state.vm.runtime.stopForTarget(t)
    state.vm.runtime.disposeTarget(t)
  })

  state.vm.runtime.targets = vmData.targets
  state.vm.runtime.executableTargets = vmData.executableTargets
  state.vm.runtime.threads = vmData.threads

  const msDelta = state.vm.runtime.currentMSecs - vmData.currentMSecs

  vmData.threads.forEach(t => {
    t.stackFrames.forEach(f => {
      if (f.executionContext && f.executionContext.timer) {
        f.executionContext.timer.startTime += msDelta
      }
    })
  })
  state.vm.runtime.ioDevices.clock._projectTimer.startTime += msDelta

  vmData.targetLayers.forEach(targetId => {
    if (targetId) {
      const target = state.vm.runtime.targets.find(t => t.id === targetId)
      if (target.isStage) {
        target.drawableID = target.renderer.createDrawable('background')
      } else {
        target.drawableID = target.renderer.createDrawable('sprite')
      }
    }
  })

  state.vm.runtime.targets.forEach(t => {
    t.updateAllDrawableProperties()
  })

  state.vm.runtime.renderer.draw()
  state.effectsCache = vmData.effectsCache
  state.glitchApplications = vmData.glitchApplications
  state.addedParts = vmData.addedParts
  Object.assign(state, stateData)

  /*
   * Loading the snapshot connects it to the vm so we need to replace it
   * with a fresh unconnecte snapshot if we want to browse forward on the
   * timeline
   */
  const newSnapshot = saveSnapshot(state)
  snapshot.vmData = newSnapshot.vmData
  snapshot.stateData = newSnapshot.stateData
  state.vm.renderer.draw()
}

module.exports = function store (state, emitter) {
  emitter.on('clear-future-stack', () => {
    state.currentHistoryItem = null
    state.future = []
  })

  emitter.on('push-history', historyItem => {
    log('push-history', historyItem)
    emitter.emit('clear-state')
    emitter.emit('cleanup-drag')
    emitter.emit('clear-future-stack')
    historyItem.snapshot = saveSnapshot(state)
    state.history.push(historyItem)
    emitter.emit('render')
  })


  emitter.on('pop-history', () => {
    log('rewinding')
    emitter.emit('pause')
    if (state.currentHistoryItem === null) {
      const historyItem = HistoryItem({actionType: 'start-browsing-timeline'})
      emitter.emit('push-history', historyItem)
      state.currentHistoryItem = state.history.pop()
    }
    state.future.push(state.currentHistoryItem)
    state.currentHistoryItem = state.history.pop()
    const {snapshot} = state.currentHistoryItem
    loadSnapshot(snapshot, state)
    emitter.emit('render')
  })

  emitter.on('pop-future', () => {
    log('forward')
    state.history.push(state.currentHistoryItem)
    state.currentHistoryItem = state.future.pop()
    const {snapshot} = state.currentHistoryItem
    loadSnapshot(snapshot, state)
    emitter.emit('render')
  })
}
